import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const host = window.location.hostname;
const isLocal = host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');
const isProd = process.env.NODE_ENV === 'production' && !isLocal;

if (isProd) {
  try {
    const agent = new BrowserAgent({
      loader_config: {
        accountID: '7326393',
        trustKey: '7326393',
        agentID: '538782447',
        licenseKey: process.env.NEW_RELIC_LICENSE_KEY,
        applicationID: '538782447',
      },
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
      },
    });

    // ✅ Tag release & environment
    const release = process.env.REACT_APP_RELEASE || 'unknown';
    const env = 'production';
    agent.api?.setCustomAttribute('release', release);
    agent.api?.setCustomAttribute('environment', env);

    console.log(`[NR] BrowserAgent initialized for ${release}`);
  } catch (err) {
    console.error('[NR] Failed to initialize agent', err);
  }
} else {
  console.log('[NR] Skipped New Relic (local/dev environment)');
}
